import { inject } from '@angular/core';
import { DocumentService } from '@core/services';
import { DocumentCategory } from '@core/enums';
import { map, Observable } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { DocumentEntity } from '@core/entities';

export class UseDocument {
  private readonly _documentService = inject(DocumentService);

  getAllDocuments(category: DocumentCategory): Observable<DocumentEntity[]> {
    return this._documentService.find(category).pipe(
      map((documents) => {
        return documents.map((document: DocumentEntity) => plainToInstance(DocumentEntity, document));
      }),
    );
  }

  uploadDocument(formData: FormData): Observable<any> {
    if (!formData.has('file') || !formData.has('category') || !formData.has('club_id')) {
      throw new Error('File, category and club_id are required');
    }

    return this._documentService.upload(formData);
  }

  moveDocumentToFolder(documentId: number, folder: DocumentCategory): Observable<any> {
    if (!documentId || !folder) {
      throw new Error('Document ID and folder are required');
    }

    return this._documentService.move({ id: documentId, category: folder });
  }

  deleteDocument(documentId: number): Observable<any> {
    if (!documentId) {
      throw new Error('Document ID is required');
    }

    return this._documentService.delete(documentId);
  }

  downloadDocument(documentName: string): Observable<Blob> {
    if (!documentName) {
      throw new Error('Document name is required');
    }

    return this._documentService.download(documentName);
  }

  getAllPersonalDocuments(): Observable<DocumentEntity[]> {
    return this._documentService.find(DocumentCategory.PERSONAL).pipe(
      map((documents) => {
        return documents.map((document: DocumentEntity) => plainToInstance(DocumentEntity, document));
      }),
    );
  }

  getAllClubDocuments(): Observable<DocumentEntity[]> {
    return this._documentService.find(DocumentCategory.CLUBS).pipe(
      map((documents) => {
        return documents.map((document: DocumentEntity) => plainToInstance(DocumentEntity, document));
      }),
    );
  }

  getAllCurrentStatusesDocuments(): Observable<DocumentEntity[]> {
    return this._documentService.find(DocumentCategory.CURRENT_STATUSES).pipe(
      map((documents) => {
        return documents.map((document: DocumentEntity) => plainToInstance(DocumentEntity, document));
      }),
    );
  }

  getAllArchiveDocuments(): Observable<DocumentEntity[]> {
    return this._documentService.find(DocumentCategory.ARCHIVE).pipe(
      map((documents) => {
        return documents.map((document: DocumentEntity) => plainToInstance(DocumentEntity, document));
      }),
    );
  }
}
